import React, { FC } from 'react';
import useReactRouter from 'use-react-router';
import { firebase_db, firebase_auth } from './config/firebase';
import {validate} from './misc'
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import {Copyright} from './material/copywrite'
import Alert from './material/alert'

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paperSub: {
    marginTop: theme.spacing(2),
    // marginLeft: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    fontWeight: 'bold',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  root: {
    '& .MuiTextField-root': {
      // margin: theme.spacing(2),
      width: 120,
    },
  },
}));

export const Invite: FC = () => {
  const [name, setName] = React.useState('');
  const [name_invalid, setNameInvalid] = React.useState(false);
  const [name_helper, setNameHelper] = React.useState('');
  const [enter_room_invalid, setEnterRoomInvalid] = React.useState(false);
  const classes = useStyles();

  firebase_auth.signInAnonymously().catch(function() {
    // Handle Errors here.
  });
  let user = firebase_auth.currentUser;
  let uid = "";
  if(user){
    uid = user.uid;
  }

  const { history, location} = useReactRouter();
  let paths = location.pathname.split("/");
  let room_id = paths[2];

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName((event.target as HTMLInputElement).value);
  };

  const handleEnterRoom = () => {
    if(!validate("name", name)){
      setNameInvalid(true);
      setNameHelper('半角英数字を1～10文字入力してください');
      return;
    }
    if(uid.length === 0){
      setEnterRoomInvalid(true);
      return;
    }
    // 部屋が存在するかチェック
    firebase_db.ref(`room/${room_id}/host`).once("value", function(snapshot){
      if(snapshot.exists()){
        // 空いている手番の確認
        firebase_db.ref(`room/${room_id}/black`).once("value", function(snapshot2){
          if(!snapshot2.exists()){
            let path = "black";
            firebase_db.ref(`room/${room_id}/${path}`).set({
              uid: uid,
              name: name,
            });
            history.push(`/room/${room_id}/${path}`);
            return;
          }
          firebase_db.ref(`room/${room_id}/white`).once("value", function(snapshot3){
            if(!snapshot3.exists()){
              let path = "white";
              firebase_db.ref(`room/${room_id}/${path}`).set({
                uid: uid,
                name: name,
              });
              history.push(`/room/${room_id}/${path}`);
            }
            else{
              setEnterRoomInvalid(true);
              return;
            }
          });
        });
      }
      else{
        setEnterRoomInvalid(true);
        return;
      }
    });
  }

  const handleEnterLive = () => {
    // 部屋が存在するかチェック
    firebase_db.ref(`room/${room_id}/host`).once("value", function(snapshot){
      if(snapshot.exists()){
        history.push(`/live/${room_id}`);
        return;
      }
      setEnterRoomInvalid(true);
      return;
    });
  }


  const handleEnterClose = () => {
    setEnterRoomInvalid(false);
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <h1 className={classes.paperSub}>
        反転将棋
      </h1>
      {/* <Typography component="h1" variant="h2">
        反転将棋
      </Typography> */}
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <TextField
            error={name_invalid}
            variant="outlined"
            margin="normal"
            // required
            fullWidth
            id="name"
            label="ユーザ名"
            name="name"
            value={name}
            onChange={handleNameChange}
            autoComplete="name"
            helperText={name_helper}
            autoFocus
          />
        </form>
        &nbsp;
      </div>
      <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleEnterRoom}
        >
          部屋に入る
      </Button>
      <hr></hr>
      <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleEnterLive}
        >
          観戦する
      </Button>
      <hr></hr>
      <Box mt={8}>
        <Copyright />
      </Box>
      <Alert
        title={"入室できません"}
        message={"部屋が存在しないか、すでに対局者の募集が終了しています。"}
        open={enter_room_invalid}
        handleClose={handleEnterClose}
      />
    </Container>
  );
}
